import { render, staticRenderFns } from "./medios_de_pago.vue?vue&type=template&id=1a5127d5&scoped=true&"
import script from "./medios_de_pago.vue?vue&type=script&lang=js&"
export * from "./medios_de_pago.vue?vue&type=script&lang=js&"
import style0 from "./medios_de_pago.vue?vue&type=style&index=0&id=1a5127d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5127d5",
  null
  
)

export default component.exports